import React from 'react';
import './CommunityCallToAction.css';
import communityIllustration from '../assets/Book Events/group.png';
import whatsappIcon from '../assets/images/whatsapp.png';
/**
 * Community WhatsApp CTA card
 *
 * Props:
 * - title: string
 * - description: string
 * - buttonText: string
 * - whatsappLink: string (URL)
 */
const CommunityCallToAction = React.memo(({
  title = 'Join Our Garbha Sanskar Community',
  description = '',
  buttonText = 'Join WhatsApp Community',
  whatsappLink = '#',
}) => {
  const isValidWhatsAppLink = (link) => {
    if (!link) return false;
    if (typeof link !== 'string') return false;
    const trimmed = link.trim();
    if (!trimmed) return false;
    // Reject common placeholders
    const lower = trimmed.toLowerCase();
    if (trimmed === '#' || lower.includes('your-community-link') || lower === 'null') return false;
    // Any non-placeholder string returned from API should be considered valid.
    return true;
  };

  const handleClick = (event) => {
    if (!isValidWhatsAppLink(whatsappLink)) {
      event.preventDefault();
    }
  };

  return (
    <section className="community-cta">
      <div className="community-cta__container container-xl">
        <div className="community-cta__illustration">
          <img
            src={communityIllustration}
            alt="Community chat illustration"
            className="community-cta__illustration-image"
            loading="lazy"
            decoding="async"
          />
        </div>

        <div className="community-cta__content">
          {title && <h2 className="community-cta__title">{title}</h2>}

          {description && (
            <p className="community-cta__description">{description}</p>
          )}

          {buttonText && isValidWhatsAppLink(whatsappLink) && (
            <div>
            <img className="community-cta__whatsapp-icon whatsapp-icon" src={whatsappIcon}/>
            <a
              href={whatsappLink}
              target="_blank"
              rel="noopener noreferrer"
              className="community-cta__button"
              onClick={handleClick}
            >
              {/* <i
                className="fab fa-whatsapp community-cta__whatsapp-icon"
                aria-hidden="true"
              ></i> */}
              {buttonText}
            </a>
            </div>
          )}
        </div>
      </div>
    </section>
  );
});

CommunityCallToAction.displayName = 'CommunityCallToAction';

export default CommunityCallToAction;

